import type { OrderEventData, PendingOrderType } from '../types/chartData'

export type PlacedOrderEvent = Extract<OrderEventData, { kind: 'order_placed' }>

/** Short names for the chart's line labels and the pane's Type column. */
export const PENDING_TYPE_LABEL: Record<PendingOrderType, string> = {
  buy_limit: 'Buy limit',
  sell_limit: 'Sell limit',
  buy_stop: 'Buy stop',
  sell_stop: 'Sell stop',
}
export const PENDING_TYPE_ABBR: Record<PendingOrderType, string> = {
  buy_limit: 'BL',
  sell_limit: 'SL',
  buy_stop: 'BS',
  sell_stop: 'SS',
}

/**
 * The orders still resting as of the playhead: placed at or before it, with no fill, cancel,
 * expiry or rejection at or before it. Shared by the trades pane's Pending tab and the chart's
 * dotted order lines, so the two never disagree about what is working.
 */
export function restingOrdersAt(activity: OrderEventData[], playheadTs: number): PlacedOrderEvent[] {
  const ended = new Set<number>()
  for (const a of activity) {
    if (a.time > playheadTs) continue
    if (
      a.kind === 'order_filled' ||
      a.kind === 'order_cancelled' ||
      a.kind === 'order_expired' ||
      a.kind === 'order_rejected'
    ) {
      ended.add(a.ticket)
    }
  }
  return activity.filter(
    (a): a is PlacedOrderEvent => a.kind === 'order_placed' && a.time <= playheadTs && !ended.has(a.ticket),
  )
}
